import React, { memo } from "react";
import { useStore } from "../../../stores";
import { observer } from "mobx-react";
import * as Yup from "yup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { ENTRY_TYPES, TYPE_GLOBAL_PROPOTIES, TYPE_GLOBAL_PROPOTIES_CANCEL_REASON } from "../../../common/LocalConst";
import { Grid } from "@material-ui/core";

function ReasonCancelCreateOrEdit({ handleAfterSubmit }) {
  const {
    openFormCreateOrEditReasonCancel,
    handleClosePopupReasonCancel,
    saveReasonCancel,
    selectedReasonCancel
  } = useStore().managementStore.reasonCancelStore;

  const validationSchema = Yup.object({
    property: Yup.string()
      .nullable()
      .test(
        "required-code",
        "Chưa có mã lý do hủy!",
        (val) => !(!Boolean(val) || val?.trim() === "")
      ),
    propertyValue: Yup.string()
      .nullable()
      .test(
        "required-name",
        "Chưa có lý do hủy",
        (val) => !(!Boolean(val) || val?.trim() === "")
      ),
    // dataType: Yup.string()
    //   .nullable()
    //   .test(
    //     "required-name",
    //     "Chưa có loại lý do hủy",
    //     (val) => !(!Boolean(val) || val?.trim() === "")
    //   ),
  });

  return (
    <PopupForm
      size="sm"
      title="Thêm lý do hủy"
      open={openFormCreateOrEditReasonCancel}
      handleClose={handleClosePopupReasonCancel}
      formik={{
        initialValues: {
          ...selectedReasonCancel,
          dataType: TYPE_GLOBAL_PROPOTIES_CANCEL_REASON,
          isActive: true, // mặc định tạo là đang sử dụng
        },
        onSubmit: async (values, { setSubmitting }) => {
          let data = await saveReasonCancel(values, { setSubmitting });
          //console.log("datadata", data);
          if (handleAfterSubmit) {
            handleAfterSubmit(data);
          }
        },
        validationSchema
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <GlobitsSelectInput
            label={"Loại"}
            name={"dataType"}
            options={TYPE_GLOBAL_PROPOTIES}
            // required
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <GlobitsTextField
            name="property"
            label="Mã Lý do hủy"
            notDelay
            required
          />
        </Grid>
        <Grid item xs={12}>
          <GlobitsTextField
            name="propertyValue"
            label="Lý do hủy"
            isTextArea
            row={3}
            required
          />
        </Grid>

      </Grid>
    </PopupForm>
  );
}

export default memo(observer(ReasonCancelCreateOrEdit));
